import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

import WorkHours from './widgets/WorkHours';
import Social from './widgets/Social';
import Online from './widgets/Online';

import * as selector from '../selectors';

const mapStateToProps = state => {
	return {
		settings: selector.getSettings(state),
	};
};

@connect(mapStateToProps)
export default class extends Component {
	static propTypes = {
		settings: PropTypes.object,
	}

	render() {
		const {
			settings: {
				phone,
				logo,
				address,
				book_off,
				menu_on,
				menu_link,
			},
		} = this.props;

		return (
			<div className="vertical-center">
				<div className="home container text-center">
					<div className="logo">
						{logo && (
							<Link to="/">
								<img src={logo} alt="" className="img-fluid" />
							</Link>
						)}
					</div>
					{!Number(book_off) && (
						<Link to="/book" className="button book_now custom-bg">Забронировать стол онлайн</Link>
					)}
					{phone && (
						<Fragment>
							<div className="phone">
								{Number(book_off) ? (
									<p>Телефон</p>
								) : (
									<p>Или позвоните по телефону</p>
								)}
								<a href={`tel:${phone}`} className="number">{phone}</a>
							</div>
							<hr />
						</Fragment>
					)}
					<WorkHours />
					{address && (
						<div className="address">
							{address.split("\n").map((item, i) => (
								<span key={i}>{item}<br /></span>
							))}
						</div>
					)}
					<hr />
					{menu_link && (
						<Fragment>
							<a href={menu_link} target="_blank" className="button show_menu custom-bg">Посмотреть меню</a>
							<hr />
						</Fragment>
					)}
					{!!Number(menu_on) && (
						<Fragment>
							<a href="/menu" className="button show_menu custom-bg">Посмотреть меню</a>
							<hr />
						</Fragment>
					)}
					<Social />
					<div className="age">
						Данное заведение запрещёно для посещения детям (18+).<br />
						При входе вас могут попросить предъявить оригинал удостоверения личности.
					</div>
				</div>
				<Online />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Home.js